import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-update-agreement',
  templateUrl: './update-agreement.component.html',
  styleUrls: ['./update-agreement.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UpdateAgreementComponent implements OnInit {

  constructor(
    private modalCtrl: ModalController
  ) { }

  @Input() id: string;
  @Input() message: string;

  d = new Date();

  ngOnInit() {/* empty */}

  dismiss() {
    this.modalCtrl.dismiss({agreed: true});
  }

}
